var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPbsTiktok = function SvgPbsTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pbs-tiktok_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25F4EE",
    d: "M5.091 5.689v-.557a4 4 0 0 0-.572-.041C2.177 5.09.272 6.985.272 9.313c0 1.428.718 2.692 1.813 3.457A4.18 4.18 0 0 1 .96 9.895C.959 7.6 2.796 5.742 5.09 5.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25F4EE",
    d: "M5.192 11.835c1.044 0 1.909-.838 1.948-1.867l.009-9.18L8.823.79 8.821.775a3 3 0 0 1-.055-.582H6.46l-.004 9.193A1.935 1.935 0 0 1 3.62 11.02a1.95 1.95 0 0 0 1.572.815M11.976 3.923v-.539c-.645 0-1.245-.19-1.748-.517.448.512 1.057.908 1.748 1.056"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2C55",
    d: "M10.228 2.867a3.17 3.17 0 0 1-.79-2.092H8.81a3.2 3.2 0 0 0 1.418 2.092M4.519 7.367c-1.07 0-1.953.883-1.953 1.946 0 .74.436 1.383 1.053 1.707a1.9 1.9 0 0 1-.367-1.125 1.936 1.936 0 0 1 2.512-1.839V5.714a4 4 0 0 0-.572-.041l-.1.002h-.01l-.006 1.773a1.8 1.8 0 0 0-.557-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2C55",
    d: "m11.977 3.895-.011-.002v1.771a5.53 5.53 0 0 1-3.214-1.037v4.686c0 2.328-1.89 4.21-4.233 4.21a4.23 4.23 0 0 1-2.434-.754 4.25 4.25 0 0 0 3.107 1.348c2.342 0 4.247-1.895 4.247-4.222V5.233a5.5 5.5 0 0 0 3.21 1.027V3.966q-.347-.001-.672-.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.765 9.313V4.652a5.5 5.5 0 0 0 3.21 1.026V3.895a3.2 3.2 0 0 1-1.748-1.027A3.2 3.2 0 0 1 8.82.775H7.13l-.003 9.193a1.94 1.94 0 0 1-3.508 1.052 1.93 1.93 0 0 1-1.04-1.707A1.936 1.936 0 0 1 5.09 7.474V5.676C2.795 5.729.944 7.601.944 9.896c0 1.11.433 2.12 1.14 2.874.69.482 1.529.765 2.434.765 2.342 0 4.247-1.894 4.247-4.222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pbs-tiktok_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.272.193h12.377v13.924H.272z"
  })))));
};
export default SvgPbsTiktok;